module.exports = __webpack_public_path__ + "img/cooperation_bg_D@.7c259cad.png";